import React from "react";

const Loading = () => {
  return (
    <div className="App">
      <h1>LOADING...</h1>
    </div>
  );
};

export default Loading;
